import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

const   Expenses = (props) => {
  const { expenses,filterStatus } = props;
  return (

    <table className="table">
      <thead>
        <tr>
          <th scope="col">Seller Name</th>
          <th scope="col">Expense Title</th>
          <th scope="col">Total</th>
          <th scope="col">Paid</th>
            <th scope="col">Due</th>
          <th scope="col">Date</th>
          <th>Status</th>
          <th scope="col" className="text-end">
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {expenses.filter(expense => {
            if(filterStatus === "all"){
                return expense
            }
            if(filterStatus === "paid"){
                //return the expense that is paid by comparing totalprice and paidprice
                if(expense.expenseTotalPrice === expense.expensePaidAmount){
                    return expense
                }
            }
            if(filterStatus === "Notpaid"){
                //return the expense that is paid by comparing totalprice and paidprice
                if(expense.expenseTotalPrice !== expense.expensePaidAmount){
                    return expense
                }
            }

        }
        ).
        map((expense) => (
          <tr key={expense._id}>
            <td>{expense.user.name}</td>
            <td>
              <b>{expense.expenseTitle}</b>
            </td>
            <td> {expense.expenseTotalPrice} TND</td>
            <td> {expense.expensePaidAmount} TND</td>
              <td> {expense.expenseDueAmount} TND</td>
            <td>
              {expense.expenseTotalPrice===expense.expensePaidAmount?
                <span className="badge  rounded-pill  alert-success">Paid</span>
                :
                <span className="badge rounded-pill  alert-danger">Not Paid</span>
                }

            </td>
            <td>{moment(expense.createdAt).format("MMM Do YY")}</td>

            <td className="d-flex justify-content-end align-item-center">
              <Link to={`/expense/${expense._id}`} className="text-success">
                <i className="fas fa-eye"></i>
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Expenses;
